import { DebtData } from '@common/hooks/useDebts/types';
import hasEntryValueForAutoDebit from './hasEntryValueForAutoDebit';
import { ClosedAgreementProps } from '@dues/pages/Partner/ClosedAgreement/types';

interface ShouldGenerateBilletProps {
  agreement: any;
  currentInstallment: any;
  billetGenerated: boolean;
}

interface CheckGenerateClosedAgreementBilletProps {
  agreement: ClosedAgreementProps;
  debtData: DebtData;
}

export function checkGenerateClosedAgreementBillet({ agreement, debtData }: CheckGenerateClosedAgreementBilletProps) {
  const { isBradesco } = debtData.currentPartner;
  const { hasInstallments } = debtData.paymentOpt;
  const { hasEntryForDebitInAcc } = debtData.paymentMeth;

  if (isBradesco && !hasEntryForDebitInAcc && hasInstallments) return;

  const isBilletSelected = agreement?.paymentOption?.paymentMethodName === 'BILLET';
  const isDebitAccSelected = agreement?.paymentOption?.paymentMethodName === 'DEBIT_ACCOUNT';
  const noBilletData = !agreement?.billetData?.linhaDigitavel;
  const debitAccWithoutBillet = isDebitAccSelected && !agreement.debitAccount?.redirectToDebitAccount && noBilletData;

  const shouldGenerateBillet = (isBilletSelected && noBilletData) || debitAccWithoutBillet;

  return shouldGenerateBillet;
}

export function shouldGenerateBillet({ agreement, currentInstallment, billetGenerated }: ShouldGenerateBilletProps) {
  const isItau = agreement.partner.identificador === 'itau';
  const isFirstInstallment = currentInstallment.installmentNumber === 1;
  const currentPaymentIsPix = agreement?.paymentMethod === 'PIX';
  const isBradesco = agreement?.partner.identificador === 'bradesco';

  const hasInstallments = agreement?.debt.detalhes?.[0].qtdParcelas;

  if (isBradesco && !hasEntryValueForAutoDebit(agreement?.properties) && hasInstallments) return false;

  const ruleItauBillet = isItau && !isFirstInstallment && currentPaymentIsPix;
  const isBilletSelected = agreement?.paymentMethod === 'BILLET';

  const shouldGenerateBillet = (isBilletSelected && !billetGenerated) || ruleItauBillet;

  return shouldGenerateBillet;
}
